import { createReducer, createActions } from 'reduxsauce'
import { omit } from 'lodash'
import FLAG from 'utils/flags'

// Initial State
export const initialState = {
    loading: FLAG.FALSE,
    loadingOpacity: 0.8,
    modalData: {
        type: null,
        title: null,
        text: null,
        callback: null, // fired when modal is dismissed
        actionBtns: [] // list of { text, action } for each button
    },
    alert: null,
    flag: {}
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        cleanModal: null,

        showLoading: ['opacity'],
        hideLoading: null,

        info: ['data'],
        success: ['data'],
        error: ['data'],
        request: ['data'],

        set: ['key', 'value'],
        setUndefined: ['key'],
        setWaiting: ['key'],
        setLoading: ['key'],
        setSuccess: ['key'],
        setOk: ['key'],
        setError: ['key'],
        setTrue: ['key'],
        setFalse: ['key'],
        remove: ['key'],

        setUndefinedWithLoading: ['key'],
        setWaitingWithLoading: ['key', 'opacity'],
        setLoadingWithLoading: ['key', 'opacity'],
        setSuccessWithLoading: ['key'],
        setErrorWithLoading: ['key'],
        removeWithLoading: ['key'],

        // Alert
        addAlert: ['alert'],
        closeAlert: null
    },
    {
        prefix: 'GLOBAL_'
    }
)
export const GlobalTypes = Types

// HELPERS:
const modalDataWithType = (state, data, type) => ({
    ...state,
    modalData: data
        ? {
            ...initialState.modalData,
            ...data,
            type
        }
        : initialState.modalData
})

const addFlag = (state, key, value) => ({ ...state, flag: { ...state.flag, [key]: value } })
const addFlagWithLoadingTrue = (state, key, value, opacity) => ({
    ...state,
    flag: { ...state.flag, [key]: value },
    loading: FLAG.TRUE,
    loadingOpacity: opacity || initialState.loadingOpacity
})
const addFlagWithLoadingFalse = (state, key, value) => ({ ...state, flag: { ...state.flag, [key]: value }, loading: FLAG.FALSE, loadingOpacity: initialState.loadingOpacity })
const removeFlag = (state, key) => ({ ...state, flag: omit(state.flag, key) })
const removeFlagWithLoading = (state, key) => ({ ...state, flag: omit(state.flag, key), loading: FLAG.FALSE, loadingOpacity: initialState.loadingOpacity })

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => initialState,
    [Types.CLEAN_MODAL]: (state = initialState) => ({ ...state, modalData: initialState.modalData }),

    [Types.SHOW_LOADING]: (state = initialState, { opacity = null }) => ({
        ...state,
        loading: FLAG.TRUE,
        loadingOpacity: opacity || initialState.loadingOpacity
    }),
    [Types.HIDE_LOADING]: (state = initialState) => ({
        ...state,
        loading: FLAG.FALSE,
        loadingOpacity: initialState.loadingOpacity
    }),

    [Types.INFO]: (state = initialState, { data }) => modalDataWithType(state, data, 'INFO'),
    [Types.SUCCESS]: (state = initialState, { data }) => modalDataWithType(state, data, 'SUCCESS'),
    [Types.ERROR]: (state = initialState, { data }) => modalDataWithType(state, data, 'ERROR'),
    [Types.REQUEST]: (state = initialState, { data }) => modalDataWithType(state, data, 'REQUEST'),

    [Types.SET]: (state = initialState, { key, value }) => addFlag(state, key, value),
    [Types.SET_UNDEFINED]: (state = initialState, { key }) => addFlag(state, key, FLAG.UNDEFINED),
    [Types.SET_WAITING]: (state = initialState, { key }) => addFlag(state, key, FLAG.WAITING),
    [Types.SET_LOADING]: (state = initialState, { key }) => addFlag(state, key, FLAG.WAITING),
    [Types.SET_SUCCESS]: (state = initialState, { key }) => addFlag(state, key, FLAG.SUCCESS),
    [Types.SET_OK]: (state = initialState, { key }) => addFlag(state, key, FLAG.SUCCESS),
    [Types.SET_ERROR]: (state = initialState, { key }) => addFlag(state, key, FLAG.ERROR),
    [Types.SET_TRUE]: (state = initialState, { key }) => addFlag(state, key, FLAG.TRUE),
    [Types.SET_FALSE]: (state = initialState, { key }) => addFlag(state, key, FLAG.FALSE),
    [Types.REMOVE]: (state = initialState, { key }) => removeFlag(state, key),

    [Types.SET_UNDEFINED_WITH_LOADING]: (state = initialState, { key }) => addFlagWithLoadingFalse(state, key, FLAG.UNDEFINED),
    [Types.SET_WAITING_WITH_LOADING]: (state = initialState, { key, opacity = null }) => addFlagWithLoadingTrue(state, key, FLAG.WAITING, opacity),
    [Types.SET_LOADING_WITH_LOADING]: (state = initialState, { key, opacity = null }) => addFlagWithLoadingTrue(state, key, FLAG.WAITING, opacity),
    [Types.SET_SUCCESS_WITH_LOADING]: (state = initialState, { key }) => addFlagWithLoadingFalse(state, key, FLAG.SUCCESS),
    [Types.SET_ERROR_WITH_LOADING]: (state = initialState, { key }) => addFlagWithLoadingFalse(state, key, FLAG.ERROR),
    [Types.REMOVE_WITH_LOADING]: (state = initialState, { key }) => removeFlagWithLoading(state, key),

    [Types.ADD_ALERT]: (state = initialState, { alert }) => ({ ...state, alert }),
    [Types.CLOSE_ALERT]: (state = initialState) => ({ ...state, alert: null })
}

export const reducer = createReducer(initialState, handlers)
export default Creators



// WEBPACK FOOTER //
// src/store/redux/global.js